"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5%;
    position: relative;
    .bg-image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
    }
    > div {
        flex: 1;
        z-index: 1;
    }
    .ecrcs-left {
        display: flex;
        justify-content: center;
        align-content: center;
        img {
            width: 100%;
        }
    }
    .ecrcs-right {
        max-width: 800px;
        padding: 3%;
        button {
            outline: none;
            border: none;
        }
    }
`;
//# sourceMappingURL=CtaSectionStyled.js.map